// extracted by mini-css-extract-plugin
export var numpadContainer = "_ig-1";
export var phoneButton = "_ig-0";